import React from 'react'
import { Button } from 'react-bootstrap'
import './NavButton.css'





const NavButton = (props) => {
  return (
    <>
    <Button className="navbar-button">{props.text}</Button>
    </>
  )
}

export default NavButton
  